import React, { useMemo } from 'react'
import PropTypes from 'prop-types'

import { Queries } from 'admin/lib/Api'
import { Select } from 'admin/lib/Forms'

/**
 * @param {{ scope: 'user'|'global' }} param0
 */
function AccountSelectInner({ value, onChange, scope = 'user', disabled }, ref) {
  const accounts = Queries.useAccounts({ scope })

  const options = useMemo(() => {
    return accounts.data?.map(account => ({
      'value': account.accountId,
      'label': account.name,
      'aria-label': account.name
    }))
  }, [accounts.data])

  return (
    <Select
      loading={accounts.isFetching && !accounts.isFetched}
      disabled={disabled || (accounts.isFetching && !accounts.isFetched)}
      mode="multiple"
      allowClear
      showSearch
      options={options}
      value={value || []}
      onChange={onChange}
      ref={ref}
    />
  )
}

export const AccountSelect = React.memo(React.forwardRef(AccountSelectInner))

AccountSelectInner.propTypes = {
  value: PropTypes.arrayOf(PropTypes.string),
  onChange: PropTypes.func,
  scope: PropTypes.oneOf(['global', 'user']),
  disabled: PropTypes.bool
}
